// extracted by mini-css-extract-plugin
module.exports = {"red":"ConfirmChangeStatus_red_3Mq5Q"};